import actionCreator from "../common/actionObjectCreator";
import moment from "moment";

import submitData from "../common/postData";

export const actionDescriptor = "portfolioEntry/";

const createAction = actionCreator(actionDescriptor);

const LOAD_DATABASE_DATES = createAction("LOAD_DATABASE_DATES");
const CHANGE_NUMBEROFPORTFOLIOS = createAction("CHANGE_NUMBEROFPORTFOLIOS");
const REMOVE_PORTFOLIO = createAction("REMOVE_PORTFOLIO");
const SET_VALUE = createAction("SET_VALUE");
const SET_ACTIVE_PORTFOLIO = createAction("SET_ACTIVE_PORTFOLIO");
const SET_ITEM_VALUE = createAction("SET_ITEM_VALUE");
const SET_CONTRIBUTION_VALUE = createAction("SET_CONTRIBUTION_VALUE");
const ADD_CONTRIBUTION_VALUE = createAction("ADD_CONTRIBUTION_VALUE");
const ADD_CONTRIBUTION_DATE = createAction("ADD_CONTRIBUTION_DATE");
const REMOVE_CONTRIBUTION = createAction("REMOVE_CONTRIBUTION");

const SET_BENCHMARK_VALUE = createAction("SET_BENCHMARK_VALUE");
const RESET = createAction("RESET");

const COPY_PORTFOLIO = createAction("COPY_PORTFOLIO");
const IMPORT_DATA = createAction("IMPORT_DATA");

// const CLEAN_DATA = createAction("CLEAN_DATA");

const LOAD_REPORT_PREVIEW = createAction("LOAD_REPORT_PREVIEW");

export function loadDatabaseDates(currency) {
  return (dispatch) => {
    submitData(
      `database/getDateRange`,
      { currency },
      LOAD_DATABASE_DATES,
      dispatch,
      true,
      {},
      "POST",
      true,
      1000,
    );
  };
}

export function loadPreview(portfolio) {
  console.log(portfolio);
  return (dispatch) => {
    submitData(
      `portfolio/getReportPreview`,
      { portfolio },
      LOAD_REPORT_PREVIEW,
      dispatch,
      true,
      {},
      "POST",
      true,
      1000,
    );
  };
}

export function setActivePortfolio(portfolio) {
  return {
    type: SET_ACTIVE_PORTFOLIO.default,
    payload: portfolio,
  };
}

export function copyPortfolio(portfolioId, callback) {
  return (dispatch) => {
    submitData(
      `Portfolio/${portfolioId}/Raw`,
      {},
      COPY_PORTFOLIO,
      dispatch,
      true,
      { portfolioId },
      "GET",
      true,
      1000,
      callback,
    );
  };
}

export function setNumberOfPortfolios(props, newNumber) {
  return {
    type: CHANGE_NUMBEROFPORTFOLIOS.default,
    number: newNumber,
  };
}
export function removePortfolio(props, portfolioNumber) {
  return {
    type: REMOVE_PORTFOLIO.default,
    portfolioNumber,
  };
}

export function setPortfolioValue(props, portfolioNumber, key, value) {
  return {
    type: SET_VALUE.default,
    portfolioNumber,
    values: [{ key, value }],
  };
}

export function setPortfolioValues(props, portfolioNumber, values) {
  return {
    type: SET_VALUE.default,
    portfolioNumber,
    values,
  };
}

export function setPortfolioItemValue(
  props,
  portfolioNumber,
  key,
  value,
  portfolioValueKey,
) {
  return {
    type: SET_ITEM_VALUE.default,
    portfolioNumber,
    key,
    value,
    portfolioValueKey,
  };
}

export function setBenchmarkValue(
  props,
  portfolioNumber,
  key,
  value,
  benchmarkKey,
) {
  return {
    type: SET_BENCHMARK_VALUE.default,
    portfolioNumber,
    key,
    value,
    benchmarkKey,
  };
}

export function addPortfolioContributionValue(
  props,
  portfolioNumber,
  date,
  itemType = "contribution",
) {
  var m = moment(date);

  const portfolioValueKey = m.format("YYYY-MM-DD");

  return {
    type: ADD_CONTRIBUTION_VALUE.default,
    portfolioNumber,
    portfolioValueKey,
    itemType,
  };
}

export function setPortfolioContributionValue(
  props,
  portfolioNumber,
  key,
  value,
  portfolioValueKey,
  itemType = "contribution",
) {
  return {
    type: SET_CONTRIBUTION_VALUE.default,
    portfolioNumber,
    key,
    value,
    portfolioValueKey,
    itemType,
  };
}

export function removeContribution(props, portfolioNumber, key) {
  return {
    type: REMOVE_CONTRIBUTION.default,
    portfolioNumber,
    key,
  };
}
export function addContributionDate(props, portfolioNumber, key) {
  return {
    type: ADD_CONTRIBUTION_DATE.default,
    portfolioNumber,
    key,
  };
}

export function importData(props, portfolioNumber, newData = {}) {
  var data = JSON.parse(JSON.stringify(newData));

  var first = data.portfolioValues[0].key;
  var last = data.portfolioValues[data.portfolioValues.length - 1].key;

  const [startYear, startMonth] = first.split("-");
  const [endYear, endMonth] = last.split("-");

  data = {
    ...data,
    startMonth: parseInt(startMonth, 10),
    startYear: parseInt(startYear, 10),
    endMonth: parseInt(endMonth, 10),
    endYear: parseInt(endYear, 10),
  };

  return {
    type: IMPORT_DATA.default,
    portfolioNumber,
    data,
  };
}

const padNumber = (value) => {
  return ("0" + value).slice(-2);
};

function fixPortfolioMonths(portfolio) {
  const { startMonth, startYear, endMonth, endYear } = portfolio;

  const backups = portfolio.portfolioValues;
  portfolio.portfolioValues = [];

  if (startMonth && endMonth && startYear && endYear) {
    var month = startMonth;
    var year = startYear;

    while (year <= endYear) {
      const maxMonth = year === endYear ? endMonth : 12;

      while (month <= maxMonth) {
        var key = `${year}-${padNumber(month)}`;
        var keyOld = `${year}-${month}`;

        //eslint-disable-next-line
        var found = backups.find((e) => e.key === key || e.key === keyOld);

        if (!found) {
          found = { key, value: "" };
        } else {
          if (found.key === keyOld) {
            found.key = key;
          }
        }

        portfolio.portfolioValues.push(found);

        month++;
      }

      month = 1;
      year++;
    }

    var end = `${endYear}-${("0" + endMonth).slice(-2)}-32`;
    var start = `${startYear}-${("0" + startMonth).slice(-2)}`;

    //eslint-disable-next-line
    var found = portfolio.contributions.filter(
      (e) => !(e.key < end && e.key > start),
    );

    for (var i in found) {
      var index = portfolio.contributions.indexOf(found[i]);
      portfolio.contributions.splice(index, 1);
    }

    found = portfolio.fees.filter((e) => !(e.key < end && e.key > start));

    for (i in found) {
      //eslint-disable-next-line
      var index = portfolio.fees.indexOf(found[i]);
      portfolio.fees.splice(index, 1);
    }
  }

  recaclulateForPPF(portfolio);

  var benchmarks = defaultState.benchmarks;

  //make sure the benchmarks are all there and updated with
  // the default values if they are missing. This is needed for when we
  // add new benchmarks to the default list and we need to make sure old
  // portfolios have those benchmarks added in with the default values
  benchmarks.forEach((bm) => {
    if (bm.key !== "clientSpecified") {
      var found = portfolio.benchmarks.find((e) => e.key === bm.key);

      if (!found) {
        portfolio.benchmarks.push({ key: bm.key, ...bm });
      } else {
        for (var key in bm) {
          if (key !== "selected" && key !== "key") {
            found[key] = bm[key];
          }
        }
      }
    }
  });
}

/**If the first portfolio values isnt 100 then we need to recalculate all values based on the new PPF and make the first portfolio 100 */
function recaclulateForPPF(portfolio) {
  var portfolioValues = portfolio.portfolioValues;

  var firstValue = portfolioValues[0];

  //if no first value or it is already 100, then we dont need to recalc the ppf
  if (!firstValue || firstValue.value === "" || firstValue.value === 100) {
    return;
  }

  if (portfolioValues.length > 0) {
    var ppf = 1;

    if (portfolioValues[0].value !== 100) {
      ppf = portfolioValues[0].value / 100;
      portfolioValues[0].value = 100;
    }

    portfolioValues.forEach((item, index) => {
      if (index !== 0) {
        item.value = item.value / ppf;
      }
    });

    var contributions = portfolio.contributions;

    contributions.forEach((cont) => {
      if (cont.contribution) {
        cont.contribution = +cont.contribution / ppf;
      }
      if (cont.cashWithdrawl) {
        cont.cashWithdrawl = +cont.cashWithdrawl / ppf;
      }
      if (cont.securitiesTransferred) {
        cont.securitiesTransferred = +cont.securitiesTransferred / ppf;
      }
      if (cont.securitiesWithdrawn) {
        cont.securitiesWithdrawn = +cont.securitiesWithdrawn / ppf;
      }
    });

    var fees = portfolio.fees;

    fees.forEach((fee) => {
      if (fee.feePaidToManager) {
        fee.feePaidToManager = +fee.feePaidToManager / ppf;
      }
    });
  }
}

export function resetPortfolio() {
  return {
    type: RESET.default,
  };
}

const defaultState = {
  settings: {
    numberOfPortfolios: 1,
  },
  benchmarks: [
    {
      key: "cdnStocks",
      oneMonthTbill: null,
      tenYearBond: null,
      secondaryIndex: null,
      mainIndex: 1,
      selected: false,
    },
    {
      key: "usStocksUnhedged",
      oneMonthTbill: null,
      tenYearBond: null,
      secondaryIndex: 1,
      mainIndex: null,
      selected: false,
    },
    {
      key: "cdnLongGovtBonds",
      oneMonthTbill: null,
      tenYearBond: 1,
      secondaryIndex: null,
      mainIndex: null,
      selected: false,
    },
    {
      key: "cdnCash",
      oneMonthTbill: 1,
      tenYearBond: null,
      secondaryIndex: null,
      mainIndex: null,
      selected: false,
    },
    {
      key: "goldETF",
      oneMonthTbill: null,
      tenYearBond: null,
      secondaryIndex: null,
      mainIndex: null,
      goldETF: 1,
      selected: false,
    },
    {
      key: "balancedCdnUnhedgedUsEquity",
      oneMonthTbill: null,
      tenYearBond: null,
      secondaryIndex: 0.5,
      mainIndex: 0.5,
      selected: false,
    },
    {
      key: "balancedCdnEquityAndCdnGovtBonds",
      oneMonthTbill: null,
      tenYearBond: 0.4,
      secondaryIndex: null,
      mainIndex: 0.6,
      selected: false,
    },
    {
      key: "balancedCdnEquityAndCdnGovtBondsPlusCash",
      oneMonthTbill: 0.1,
      tenYearBond: 0.4,
      secondaryIndex: null,
      mainIndex: 0.5,
      selected: false,
    },
    {
      key: "balancedCdnAndUsEquityAndCdnGovtBonds",
      oneMonthTbill: 0.1,
      tenYearBond: 0.3,
      secondaryIndex: 0.3,
      mainIndex: 0.3,
      selected: false,
    },
    {
      key: "worldDeveloped",
      oneMonthTbill: 0,
      tenYearBond: 0,
      secondaryIndex: 0,
      mainIndex: 0,
      worldDeveloped: 1,
      selected: false,
    },
  ],
  portfolios: [
    {
      portfolioValues: [],
      contributions: [],
      fees: [],
      benchmarks: [],
      portfolioNumber: 1,
    },
    // {
    //   portfolioValues: [{ key: '2009-4', value: "1" }], contributions: [{ contribution: "1", key: "2009-03-31" }], fees: [{ feePaidToManager: "1", key: "2009-03-31" }],
    //   benchmarks: [], portfolioNumber: 1, name: 'New Portfolio',
    //   startYear: 2009, startMonth: 3, endYear: 2009, endMonth: 4, addtionalBenchmarksBypass: true
    // }
  ],
};

fixPortfolioMonths(defaultState.portfolios[0]);

//eslint-disable-next-line
function uuidv4() {
  //eslint-disable-next-line
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    //eslint-disable-next-line
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16),
  );
}

const reducer = (state = defaultState, action) => {
  var ret;
  var item;
  var node;

  switch (action.type) {
    case RESET.default:
      ret = Object.assign({}, state, { reportPreview: undefined });

      ret.portfolios = [];
      ret.portfolios.push({
        portfolioValues: [],
        contributions: [],
        fees: [],
        benchmarks: JSON.parse(JSON.stringify(ret.benchmarks)),
        portfolioNumber: 1,
        name: "",
        id: "",
      });
      return ret;
    case SET_ACTIVE_PORTFOLIO.default:
      ret = Object.assign({}, state, { reportPreview: undefined });

      state.portfolios[0] = JSON.parse(JSON.stringify(action.payload));
      return ret;

    case COPY_PORTFOLIO.pending:
      return Object.assign({}, state, {
        copying: true,
        reportPreview: undefined,
      });
    case COPY_PORTFOLIO.fulfilled:
      ret = Object.assign({}, state, { copying: false });

      state.portfolios[0] = JSON.parse(JSON.stringify(action.payload));
      fixPortfolioMonths(state.portfolios[0]);

      return ret;

    case IMPORT_DATA.default:
      ret = Object.assign({}, state, { reportPreview: undefined });

      ret.portfolios[action.portfolioNumber - 1] = {
        ...ret.portfolios[action.portfolioNumber - 1],
        ...action.data,
      };

      fixPortfolioMonths(ret.portfolios[action.portfolioNumber - 1]);
      return ret;

    case SET_VALUE.default:
      ret = Object.assign({}, state, { reportPreview: undefined });

      for (var i in action.values) {
        ret.portfolios[action.portfolioNumber - 1][action.values[i].key] =
          action.values[i].value;
      }

      var keys = ["startMonth", "endMonth", "startYear", "endYear"];

      if (action.values.find((e) => keys.indexOf(e.key) >= 0))
        fixPortfolioMonths(ret.portfolios[action.portfolioNumber - 1]);

      return ret;
    // return JSON.parse(JSON.stringify(ret));
    case SET_ITEM_VALUE.default:
      ret = Object.assign({}, state, { reportPreview: undefined });
      item = ret.portfolios[action.portfolioNumber - 1].portfolioValues.find(
        (e) => e.key === action.portfolioValueKey,
      );

      //eslint-disable-next-line
      var i =
        ret.portfolios[action.portfolioNumber - 1].portfolioValues.indexOf(
          item,
        );

      item = { ...item, [action.key]: action.value };

      ret.portfolios[action.portfolioNumber - 1].portfolioValues[i] = item;

      return ret;
    // return JSON.parse(JSON.stringify(ret));

    case SET_CONTRIBUTION_VALUE.default:
      ret = Object.assign({}, state, { reportPreview: undefined });

      node =
        action.itemType === "contribution"
          ? ret.portfolios[action.portfolioNumber - 1].contributions
          : action.itemType === "fees"
            ? ret.portfolios[action.portfolioNumber - 1].fees
            : [];

      item = node.find((e) => e.key === action.portfolioValueKey);

      if (!item) {
        item = {
          key: action.portfolioValueKey,
        };

        node.push(item);
      }

      item[action.key] = action.value;

      return ret;

    case REMOVE_CONTRIBUTION.default:
      ret = Object.assign({}, state, { reportPreview: undefined });

      var found = ret.portfolios[action.portfolioNumber - 1].contributions.find(
        (e) => e.key === action.key,
      );

      if (found) {
        ret.portfolios[action.portfolioNumber - 1].contributions.splice(
          ret.portfolios[action.portfolioNumber - 1].contributions.indexOf(
            found,
          ),
          1,
        );
      }

      found = ret.portfolios[action.portfolioNumber - 1].fees.find(
        (e) => e.key === action.key,
      );

      if (found) {
        ret.portfolios[action.portfolioNumber - 1].fees.splice(
          ret.portfolios[action.portfolioNumber - 1].fees.indexOf(found),
          1,
        );
      }

      return ret;
    case ADD_CONTRIBUTION_DATE.default:
      ret = Object.assign({}, state, { reportPreview: undefined });

      if (
        !ret.portfolios[action.portfolioNumber - 1].contributions.find(
          (e) => e.key === action.key,
        )
      ) {
        ret.portfolios[action.portfolioNumber - 1].contributions.push({
          key: action.key,
        });
      }

      return ret;

    case ADD_CONTRIBUTION_VALUE.default:
      ret = Object.assign({}, state, { reportPreview: undefined });

      node =
        action.itemType === "contribution"
          ? ret.portfolios[action.portfolioNumber - 1].contributions
          : action.itemType === "fees"
            ? ret.portfolios[action.portfolioNumber - 1].fees
            : [];

      item = node.find((e) => e.key === action.portfolioValueKey);

      if (!item) {
        node.push({ key: action.portfolioValueKey });
      }

      return ret;

    case SET_BENCHMARK_VALUE.default:
      ret = Object.assign({}, state, { reportPreview: undefined });
      item = ret.portfolios[action.portfolioNumber - 1].benchmarks.find(
        (e) => e.key === action.benchmarkKey,
      );

      if (!item) {
        item = { key: action.benchmarkKey };
        ret.portfolios[action.portfolioNumber - 1].benchmarks.push(item);
      }

      item[action.key] = action.value;

      return ret;
    // return JSON.parse(JSON.stringify(ret));

    case CHANGE_NUMBEROFPORTFOLIOS.default:
      var newSettings = Object.assign({}, state.settings, {
        numberOfPortfolios: action.number,
        reportPreview: undefined,
      });
      var portfolios = state.portfolios.slice(0);

      while (portfolios.length < action.number) {
        portfolios.push({
          portfolioNumber: portfolios.length + 1,
          name: `Portfolio #${portfolios.length + 1}`,
          portfolioValues: [],
          contributions: [],
          benchmarks: [],
        });
      }

      while (portfolios.length > action.number) {
        portfolios.pop();
      }

      ret = Object.assign({}, state, { settings: newSettings, portfolios });
      return ret;

    case REMOVE_PORTFOLIO.default:
      ret = Object.assign({}, state, { reportPreview: undefined });
      ret.portfolios.splice(action.portfolioNumber - 1, 1);

      let count = 1;
      ret.portfolios.forEach((element) => {
        element.portfolioNumber = count++;
      });

      return ret;
    case LOAD_DATABASE_DATES.pending:
      ret = Object.assign({}, state, { loading: true });
      return ret;
    case LOAD_DATABASE_DATES.fulfilled:
      ret = Object.assign({}, state, {
        loading: false,
        dateRange: action.payload,
      });
      return ret;
    // case CLEAN_DATA.default:
    //   ret = Object.assign({}, state);
    //   console.log(ret)
    //   fixPortfolioMonths(ret.portfolios[action.portfolioNumber - 1]);

    //   return ret;
    case LOAD_REPORT_PREVIEW.pending:
      ret = Object.assign({}, state, {
        reportPreview: {
          isLoading: true,
        },
      });
      return ret;

    case LOAD_REPORT_PREVIEW.fulfilled:
      ret = Object.assign({}, state, {
        reportPreview: {
          isLoading: false,
          data: action.payload,
        },
      });
      return ret;
    case LOAD_REPORT_PREVIEW.fulfilled:
      ret = Object.assign({}, state, {
        reportPreview: {
          isLoading: false,
          isError: true,
        },
      });
      return ret;

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/portfolioEntryWizard/portfolioEntry.duck.js